// External imports
import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { Button, Grid, Paper, Typography } from '@material-ui/core';
// Internal imports
import { getSSONoAccountCopy } from '~/app/Pages/SSOAccountPicker/helpers/ssoHelpers';
import modernRobot from '~/images/ModernRobot.png';
// Styling imports
import { withStyles } from '@material-ui/core/styles';
import { styles } from '~/app/Pages/SSOAccountPicker/css/accountPickerStyles.js';

/**
 * Displayed when a user authenticates via SSO but has no CLO accounts
 * associated to their identity.
 *
 * @component
 * @category SSO
 * @see CLO-11566
 */
const SSONoAccount = props => {
  const { classes } = props;
  const history = useHistory();

  const { mainText, subText, reasonCode } = getSSONoAccountCopy({ search: window.location.search });

  /**
   * Routes the user back to the login screen.
   */
  const handleBack = () => history.push({ pathname: '/' });

  return (
    <Grid
      id="ssoNoAccountContainer"
      container
      direction="column"
      alignItems="center"
      justify="center"
      className={classes.noAccountContainer}
    >
      <Grid item>
        <Paper className={classes.noAccountPaper} elevation={2}>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <img
                id="imgSSONoAccount"
                className={classes.noAccountIllustration}
                src={modernRobot}
                alt="No account found"
              />
            </Grid>
            <Grid item>
              <Typography className={classes.noAccountHeading}>{mainText}</Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.noAccountSubheading}>{subText}</Typography>
            </Grid>
            {reasonCode ? (
              <Grid item>
                <Typography id="txtSSONoAccountReasonCode" className={classes.noAccountReasonCode}>
                  Error code: {reasonCode}
                </Typography>
              </Grid>
            ) : null}
            <Grid item>
              <Button
                id="lnkBackSSONoAccount"
                variant="text"
                color="primary"
                className={classes.noAccountBackButton}
                onClick={handleBack}
              >
                &#8592; Back to Log In
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default withRouter(withStyles(styles)(SSONoAccount));
